import React from 'react';
import PropTypes from 'prop-types';

import './lazyLoadPlaceholder.css';

export const LazyLoadPlaceholder = ({ width='100%', height='100%' }) => {
    return <div width={width} height={height} id='wb-lazy-img-loading'></div>;
};

LazyLoadPlaceholder.displayName = 'LazyLoadPlaceholder';

LazyLoadPlaceholder.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ])
};
